export default function log(...args) {
	if (window.console && window.console.log) {
		window.console.log('[ZDFCMP]', ...args);
	}
}
